import { useState, useEffect } from "react";
import React from "react";
import { getCountry, getState, getPlaceOfissue, getNationality, getRelationship, getInsuranceType, postEmployeeDependentInfo, getEmployeeAddress, getEmployeeDependentInfoForForm, getNotificationId } from "../service/DirectorAPI";
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import moment from "moment";
import $ from 'jquery';
import { connect } from 'react-redux';
import Loader from '../StaticComponent/Loader';
import { encryptStorage } from '../constant'

function DependentDetails(props) {
const [DisableSubmitBtn, setDisableSubmitBtn] = useState(false);
    let dependentDataObj = {
        id: "",
        Relationship: "select",
        Name: "",
        DOB: "",
        PlaceOfBirth: "",
        IsEmployeed: "-1",
        OrganizationName: "",
        Designation: "",
        Compensation: "",
        WorkLocation: "",
        IsSmoker: "-1",
        Nationality: "select",
        IsInsured: "-1",
        TypeOfInsurance: "select",
        InsuredWith: "",
        ContactNumber: "",
        AlternateNumber: "",
        DoTheyHavePassport: "",
        NameInPassport: "",
        PassportNumber: "",
        DateOfExpiry: "",
        DateOfIssue: "",
        PlaceOfIssue: "",
        ECNR: "",
    }

    let dependentAddress = {
        SameAsEmployeeAddress: "0",
        House_number: "",
        Street: "",
        Area: "",
        Town: "",
        State: "select",
        Country: "select",
        Pincode: ""
    }

    let oldValue = {
        id: "",
        Relationship: "select",
        Name: "",
        DOB: "",
        PlaceOfBirth: "",
        IsEmployeed: "",
        OrganizationName: "",
        Designation: "",
        Compensation: "",
        WorkLocation: "",
        IsSmoker: "",
        Nationality: "select",
        IsInsured: "",
        TypeOfInsurance: "",
        InsuredWith: "",
        ContactNumber: "",
        AlternateNumber: "",
        SameAsEmployeeAddress: "0",
        House_number: "",
        Street: "",
        Area: "",
        Town: "",
        State: "",
        Country: "",
        Pincode: "",
        DoTheyHavePassport: "",
        NameInPassport: "",
        PassportNumber: "",
        DateOfExpiry: "",
        DateOfIssue: "",
        PlaceOfIssue: "",
        ECNR: "",
    }

    let olddependentAddress = {
        SameAsEmployeeAddress: "0",
        House_number: "",
        Street: "",
        Area: "",
        Town: "",
        State: "",
        Country: "",
        Pincode: ""

    }

    const [dependentData, setDependentData] = useState(dependentDataObj);
    const [dependentaddress, setDependentaddress] = useState(dependentAddress);
    const [Oldvalue, setOldvalue] = useState(oldValue);
    const [Oldaddressvalue, setOldaddressvalue] = useState(olddependentAddress);
    let dropDownArraycurrentcountry = [];
    const [arrDropDowncurrentcountry, setarrDropDowncurrentcountry] = useState(dropDownArraycurrentcountry);
    let dropDownArraycurrentstate = [];
    const [arrDropDowncurrentstate, setarrDropDowncurrentstate] = useState(dropDownArraycurrentstate);
    let relatioshipData = [];
    const [arrDropDownrelatioship, setarrDropDownRelatioship] = useState(relatioshipData);
    let nationality = [];
    const [arrDropNationality, setarrDropNationality] = useState(nationality);
    let typeOfInsurance = [];
    const [arrDropinsuranceType, setarrDropInsuranceType] = useState(typeOfInsurance);
    let dropDownArrayPlaceOfIssue = [];
    const [arrDropDownplaceofissue, setarrDropDownplaceofissue] = useState(dropDownArrayPlaceOfIssue);
    let [pagemode, setpagemode] = useState("false");
    const [showPassportField, setShowPassportField] = useState(false)
    const [contactNumber, setcontactNumber] = useState("")
    const [EmpId, setEmpId] = useState(props.empId);
    const [submit, setSubmit] = useState("Save");
    let loginEmpId = encryptStorage.getItem("employeeId")
    let role = encryptStorage.getItem("role")
    const [showEmploymentField, setShowEmploymentField] = useState(false);
    const [showInsuranceField, setInsuranceField] = useState(false);
    const [hideForm, setHideForm] = useState(true);
    const [notification, setNotification] = useState([]);
    const [reportstoId, setReportstoId] = useState("");
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
          setDisableSubmitBtn(false);

        setEmpId(props.empId);
        LoadDatacurrentcountry();
        LoadDataNationality();
        LoadDataRelationship();
        LoadDataInsuranceType();
        LoadPlaceOfIssue();
    }, []);

    useEffect(() => {

        if (props.isDependentClicked) {

            setHideForm(props.hideDependentForm);
            $("body").addClass("removeScroll");

            if (props.empId != undefined) {
                setEmpId(props.empId)
            }
            if (props.Mode != undefined) {
                if (props.Mode == 'Edit') {
                    setpagemode('true')
                    setSubmit('Update')
                } else {
                    setpagemode('false')
                    setSubmit('Save')
                }
            }
            if (props.Id != undefined && props.Id != 0) {

                let objedit = {

                    emp_id: props.empId,
                    id: props.Id,
                    reports_to: loginEmpId,
                    role: role
                };

                selecteditarray(objedit);

            }
        }

    }, [props])


    const LoadDatacurrentcountry = async () => {
        let countryData = {};
        let responsedata = await getCountry(countryData);
        setarrDropDowncurrentcountry(responsedata.data.ResponseData[0]);
    };

    const LoadDatacurrentstate = async (e) => {
        let countryId = { country_id: e.target.value };
        let responsedata = await getState(countryId);
        setarrDropDowncurrentstate(responsedata.data.ResponseData[0]);
    };

    const LoadDataNationality = async (e) => {
        
        let nationality = {};
        let responsedata = await getNationality(nationality);
        setarrDropNationality(responsedata.data.ResponseData[0]);
    };

    const EditLoadstate = async (e) => {
        let countryId = { country_id: e };
        let responsedata = await getState(countryId);
        setarrDropDowncurrentstate(responsedata.data.ResponseData[0]);
    };


    const LoadDataRelationship = async (e) => {
        
        let relationship = {};
        let responsedata = await getRelationship(relationship);
        setarrDropDownRelatioship(responsedata.data.ResponseData[0]);
    };

    const LoadDataInsuranceType = async (e) => {
        let insuranceType = {};
        let responsedata = await getInsuranceType(insuranceType);
        setarrDropInsuranceType(responsedata.data.ResponseData[0]);
    };


    const LoadPlaceOfIssue = async () => {
        let PlaceOfIssueData = {};
        let responsedata = await getPlaceOfissue(PlaceOfIssueData);
        setarrDropDownplaceofissue(responsedata.data.ResponseData[0]);

    };

    const buildPlaceOfIssue = () => {
        return arrDropDownplaceofissue.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };



    const buildcurrentcountry = () => {
        return arrDropDowncurrentcountry.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    const buildcurrentstate = () => {
        return arrDropDowncurrentstate.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    const buildRelationship = () => {
        return arrDropDownrelatioship.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    const buildNationality = () => {
        return arrDropNationality.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    const buildInsuranceType = () => {
        return arrDropinsuranceType.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    let rejexvalidation = {

        personalMailId: "",
        ContactNumber: "",
        AlternateNumber: ""

    }
    const [rejexMessage, setRejexMessage] = useState(rejexvalidation);

    const OnChangeName = (e) => {


        e.preventDefault();
        var regexItem;
        var checkValid;

        if (e.target.name == "ContactNumber") {
            regexItem = new RegExp("^[0-9]*$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                setcontactNumber("enter a valid Contact Number")

            } else {
                setcontactNumber("")
            }
        }

        // if (e.target.name == "AlternateNumber") {
        //     regexItem = new RegExp("^[0-9]*$");
        //     checkValid = regexItem.test(e.target.value);
        //     if (checkValid == false) {
        //         setAlternateNumber("Enter a Valid Alternate Number");

        //     } else {
        //         setAlternateNumber("");
        //     }
        // }

        setDependentData({ ...dependentData, [e.target.name]: e.target.value });
        setmessage({ ...message, [e.target.name]: "" });

    };

    const OnAddressChange = (e) => {



        e.target.checked == true
            ? setDependentaddress({ ...dependentaddress, [e.target.name]: 1 })
            : setDependentaddress({ ...dependentaddress, [e.target.name]: 0 });

        e.target.checked == true
            ? LoadEmpAddressData()
            : clearaddressvalue();

        if (e.target.name != "SameAsEmployeeAddress") {

            setDependentaddress({ ...dependentaddress, [e.target.name]: e.target.value });
            setmessage({ ...message, [e.target.name]: "" });

        }
    };

    const OnClickEcnr = (e) => {

        if ((dependentData.ECNR == "Stamped" && e.target.id == "Stamped") || (dependentData.ECNR == "yet to stamp" && e.target.id == "yet to stamp")) {
            setDependentData({ ...dependentData, [e.target.name]: "" });
        } else {
            setDependentData({ ...dependentData, [e.target.name]: e.target.id });
        }
        setmessage({ ...message, [e.target.name]: "" });

    };

    const OnRadioClick = (e) => {

        if (e.target.id == "Yes") {

            setDependentData({ ...dependentData, [e.target.name]: 1 });
            setmessage({ ...message, [e.target.name]: "" });

        }
        if (e.target.id == "No") {
            setDependentData({ ...dependentData, [e.target.name]: 0 });
            setmessage({ ...message, [e.target.name]: "" });

        }

        if (e.target.id == "Yes" && e.target.name == "IsInsured") {

            setInsuranceField(true);

        }
        else if (e.target.id == "No" && e.target.name == "IsInsured") {

            setInsuranceField(false);
        }

        if (e.target.id == "Yes" && e.target.name == "IsEmployeed") {
            setShowEmploymentField(true)
        } else if (e.target.id == "No" && e.target.name == "IsEmployeed") {

            setShowEmploymentField(false);

        }

    };


    const handleChecked = (e) => {


        e.target.checked == true
            ? setDependentData({ ...dependentData, [e.target.name]: 1 })
            : setDependentData({ ...dependentData, [e.target.name]: 0 });

        setmessage({ ...message, [e.target.name]: "" });


        if (e.target.name == "SameAsEmployeeAddress") {

        }

        if (e.target.name == "DoTheyHavePassport") {

            e.target.checked == true
                ? setShowPassportField(true)
                : setShowPassportField(false);
        }


    };


    const clearaddressvalue = () => {
        let oldvalueobj = {
            SameAsEmployeeAddress: "0",
            House_number: "",
            Street: "",
            Area: "",
            Town: "",
            State: "select",
            Country: "select",
            Pincode: "",
        }
        setDependentaddress(oldvalueobj);

    }


    const LoadEmpAddressData = async () => {

        let objedit = {

            emp_id: props.empId,
            id: props.Id,
            reports_to: loginEmpId,
            role: role,
            address_type: "Current Address"
        };

        let responsedata = await getEmployeeAddress(objedit);
        let countryId = { country_id: responsedata?.data?.ResponseData[0][0]?.country }
        let data = await getState(countryId);
        if (data.data.status == 200 && data.data != undefined && data.data != null && data.data?.ResponseData[0]?.length != 0) {
            setarrDropDowncurrentstate(data.data.ResponseData[0]);
        }

        if (responsedata.data.status == 200 && responsedata.data != undefined && responsedata.data != null && responsedata.data?.ResponseData[0]?.length != 0) {
            let oldvalueobj = {
                SameAsEmployeeAddress: 1,
                House_number: responsedata.data.ResponseData[0][0].house_num,
                Street: responsedata.data.ResponseData[0][0].street,
                Area: responsedata.data.ResponseData[0][0].area,
                Town: responsedata.data.ResponseData[0][0].town,
                State: responsedata.data.ResponseData[0][0].state,
                Country: responsedata.data.ResponseData[0][0].country,
                Pincode: responsedata.data.ResponseData[0][0].pincode,
            }
            setDependentaddress(oldvalueobj);


            if (responsedata?.data?.ResponseData[0][0]?.house_num != "") {
                message.House_number = ""
                setmessage({ ...message });
            }
            if (responsedata?.data?.ResponseData[0][0]?.street) {
                message.Street = ""
                setmessage({ ...message });
            }
            if (responsedata?.data?.ResponseData[0][0]?.area != "") {
                message.Area = ""
                setmessage({ ...message });
            }
            if (responsedata?.data?.ResponseData[0][0]?.town != "") {
                message.Town = ""
                setmessage({ ...message });
            }
            if (responsedata?.data?.ResponseData[0][0]?.state != "") {
                message.State = ""
                setmessage({ ...message });
            }
            if (responsedata?.data?.ResponseData[0][0]?.country != "") {
                message.Country = ""
                setmessage({ ...message });
            }
            if (responsedata?.data?.ResponseData[0][0]?.pincode != "") {
                message.Pincode = ""
                setmessage({ ...message });
            }
        }

    }


    let validationFields = {
        Relationship: "",
        Name: "",
        DOB: "",
        PlaceOfBirth: "",
        IsEmployeed: "",
        OrganizationName: "",
        Designation: "",
        Compensation: "",
        WorkLocation: "",
        IsSmoker: "",
        Nationality: "",
        IsInsured: "",
        TypeOfInsurance: "",
        InsuredWith: "",
        ContactNumber: "",
        AlternateNumber: "",
        DoTheyHavePassport: "",
        NameInPassport: "",
        PassportNumber: "",
        DateOfExpiry: "",
        DateOfIssue: "",
        PlaceOfIssue: "",
        ECNR: "",
        SameAsEmployeeAddress: "",
        House_number: "",
        Street: "",
        Area: "",
        Town: "",
        State: "",
        Country: "",
        Pincode: ""

    }
    const [message, setmessage] = useState(validationFields);

    const validation = () => {
        
        if (dependentData.Relationship == "" || dependentData.Relationship == "select") {

            message.Relationship = "Relationship is required"
            setmessage({ ...message });
        } else {
            message.Relationship = ""
            setmessage({ ...message });

        }
        if (dependentData.Name.trim() == "") {

            message.Name = "Name is required"
            setmessage({ ...message });

        } else {
            message.Name = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(dependentData.Name)
            if (checkregex) {

                message.Name = "Enter a Valid Name"
                setmessage({ ...message });
            } else {
                message.Name = ""
                setmessage({ ...message });
            }

        }

        if (dependentData.DOB == "") {

            message.DOB = "Date of birth is required"
            setmessage({ ...message });

        } else {
            message.DOB = ""
            setmessage({ ...message });

        }
        if (dependentData.PlaceOfBirth.trim() == "") {

            message.PlaceOfBirth = "Place of birth is required"
            setmessage({ ...message });

        } else {
            message.PlaceOfBirth = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(dependentData.PlaceOfBirth)
            if (checkregex) {

                message.PlaceOfBirth = "Enter a Valid Place of birth"
                setmessage({ ...message });
            } else {
                message.PlaceOfBirth = ""
                setmessage({ ...message });

            }

        }
        if (dependentData.IsEmployeed == -1) {

            message.IsEmployeed = "Is Employeed is required"
            setmessage({ ...message });

        } else {
            message.IsEmployeed = ""
            setmessage({ ...message });

        }

        if (dependentData.IsEmployeed == 1) {
            if (dependentData.OrganizationName.trim() == "") {

                message.OrganizationName = "Organization name is required"
                setmessage({ ...message });

            } else {
                message.OrganizationName = ""
                setmessage({ ...message });

            }
            if (dependentData.Designation.trim() == "") {

                message.Designation = "Designation is required"
                setmessage({ ...message });

            } else {
                message.Designation = ""
                setmessage({ ...message });

                let checkregex = OnlyNumberSpecialChar(dependentData.Designation)
                if (checkregex) {

                    message.Designation = "Enter a Valid Designation"
                    setmessage({ ...message });
                } else {
                    message.Designation = ""
                    setmessage({ ...message });

                }

            }
            if (dependentData.Compensation.trim() == "") {

                message.Compensation = "Compensation is required"
                setmessage({ ...message });

            } else {
                message.Compensation = ""
                setmessage({ ...message });

            }
            if (dependentData.WorkLocation.trim() == "") {

                message.WorkLocation = "Work location is required"
                setmessage({ ...message });

            } else {
                message.WorkLocation = ""
                setmessage({ ...message });

                let checkregex = OnlyNumberSpecialChar(dependentData.WorkLocation)
                if (checkregex) {

                    message.WorkLocation = "Enter a Valid Work location"
                    setmessage({ ...message });
                } else {
                    message.WorkLocation = ""
                    setmessage({ ...message });

                }

            }
        } else {

            message.OrganizationName = ""
            setmessage({ ...message });

            message.Designation = ""
            setmessage({ ...message });

            message.Compensation = ""
            setmessage({ ...message });

            message.WorkLocation = ""
            setmessage({ ...message });

        }


        if (dependentData.IsSmoker == -1) {

            message.IsSmoker = "Please Enter Smoker"
            setmessage({ ...message });

        } else {
            message.IsSmoker = ""
            setmessage({ ...message });

        }
        if (dependentData.Nationality == "" || dependentData.Nationality == "select") {

            message.Nationality = "Please Enter Nationality"
            setmessage({ ...message });

        } else {
            message.Nationality = ""
            setmessage({ ...message });

        }

        if (dependentData.IsInsured == "-1") {

            message.IsInsured = "Insured is required"
            setmessage({ ...message });

        } else {
            message.IsInsured = ""
            setmessage({ ...message });

        }

        if (dependentData.IsInsured == 1) {
            if (dependentData.TypeOfInsurance == "" || dependentData.TypeOfInsurance == "select") {

                message.TypeOfInsurance = "Type of insurance is required"
                setmessage({ ...message });

            } else {
                message.TypeOfInsurance = ""
                setmessage({ ...message });

            }
            if (dependentData.InsuredWith.trim() == "") {

                message.InsuredWith = "Insured With is required"
                setmessage({ ...message });

            } else {
                message.InsuredWith = ""
                setmessage({ ...message });

                let checkregex = OnlyNumberSpecialChar(dependentData.InsuredWith)
                if (checkregex) {

                    message.InsuredWith = "Enter a Valid Insured With"
                    setmessage({ ...message });
                } else {
                    message.InsuredWith = ""
                    setmessage({ ...message });

                }

            }
        } else {

            message.TypeOfInsurance = ""
            setmessage({ ...message });
            message.InsuredWith = ""
            setmessage({ ...message });

        }

        if (dependentData.ContactNumber.trim() == "") {

            message.ContactNumber = "Contact no is required"
            setmessage({ ...message });

        } else {
            message.ContactNumber = ""
            setmessage({ ...message });

        }

        // if (dependentData.AlternateNumber.trim() == "") {

        //     message.AlternateNumber = "Alternate contact no is required"
        //     setmessage({ ...message });

        // } else {
        //     message.AlternateNumber = ""
        //     setmessage({ ...message });

        // }



        if (dependentData.NameInPassport.trim() == "" && dependentData.DoTheyHavePassport == 1) {

            message.NameInPassport = "Name as in passport is required"
            setmessage({ ...message });

        } else {
            message.NameInPassport = ""
            setmessage({ ...message });
        }

        if (dependentData.NameInPassport.trim() != "" && dependentData.DoTheyHavePassport == 1) {
            let checkregex = OnlyNumberSpecialChar(dependentData.NameInPassport)
            if (checkregex) {

                message.NameInPassport = "Enter a Valid Name as in passport"
                setmessage({ ...message });
            } else {
                message.NameInPassport = ""
                setmessage({ ...message });

            }
        }

        if (dependentData.PassportNumber.trim() == "" && dependentData.DoTheyHavePassport == 1) {

            message.PassportNumber = "Passport Number is required"
            setmessage({ ...message });

        } else {
            message.PassportNumber = ""
            setmessage({ ...message });
        }

        // if (dependentData.PassportNumber.trim() != "" && dependentData.DoTheyHavePassport == 1) {
        //     let checkregex = OnlyNumberSpecialChar(dependentData.PassportNumber)
        //     if (checkregex) {

        //         message.PassportNumber = "Enter a Valid Passport Number"
        //         setmessage({ ...message });
        //     } else {
        //         message.PassportNumber = ""
        //         setmessage({ ...message });

        //     }
        // }

        if (dependentData.DateOfExpiry == "" && dependentData.DoTheyHavePassport == 1) {

            message.DateOfExpiry = "Date of expiry is required"
            setmessage({ ...message });

        } else {
            message.DateOfExpiry = ""
            setmessage({ ...message });

        }
        
        if (dependentData.DateOfIssue == "" && dependentData.DoTheyHavePassport == 1) {

            message.DateOfIssue = "Date of issue is required"
            setmessage({ ...message });

        } else {
            message.DateOfIssue = ""
            setmessage({ ...message });

        }

        if ((dependentData.PlaceOfIssue == "" || dependentData.PlaceOfIssue == "select") && dependentData.DoTheyHavePassport == 1) {

            message.PlaceOfIssue = "Place of issue is required"
            setmessage({ ...message });

        } else {
            message.PlaceOfIssue = ""
            setmessage({ ...message });

        }
        // if (dependentData.ECNR == "" && dependentData.DoTheyHavePassport == 1) {

        //     message.ECNR = "ECNR is required"
        //     setmessage({ ...message });

        // } else {
        //     message.ECNR = ""
        //     setmessage({ ...message });

        // }

        if (dependentaddress.House_number.trim() == "") {

            message.House_number = "House/building is required"
            setmessage({ ...message });

        } else {
            message.House_number = ""
            setmessage({ ...message });
            
            // let checkregex = OnlyNumberSpecialChar(dependentaddress.House_number)
            // if (checkregex) {

            //     message.House_number = "Enter a Valid House/building"
            //     setmessage({ ...message });
            // } else {
            //     message.House_number = ""
            //     setmessage({ ...message });

            // }

        }

        if (dependentaddress.Street.trim() == "") {

            message.Street = "Road/Street/Lane is required"
            setmessage({ ...message });

        } else {
            message.Street = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(dependentaddress.Street)
            if (checkregex) {

                message.Street = "Enter a Valid Road/Street/Lane"
                setmessage({ ...message });
            } else {
                message.Street = ""
                setmessage({ ...message });

            }

        }

        if (dependentaddress.Area.trim() == "") {

            message.Area = "Area/Locality/Sub Division is required"
            setmessage({ ...message });

        } else {
            message.Area = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(dependentaddress.Area)
            if (checkregex) {

                message.Area = "Enter a Valid Area/Locality/Sub Division"
                setmessage({ ...message });
            } else {
                message.Area = ""
                setmessage({ ...message });

            }

        }

        if (dependentaddress.Town.trim() == "") {

            message.Town = "Town/City/District is required"
            setmessage({ ...message });

        } else {
            message.Town = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(dependentaddress.Town)
            if (checkregex) {

                message.Town = "Enter a Valid Town/City/District"
                setmessage({ ...message });
            } else {
                message.Town = ""
                setmessage({ ...message });

            }

        }

        if (dependentaddress.State == "select") {

            message.State = "State is required"
            setmessage({ ...message });

        } else {
            message.State = ""
            setmessage({ ...message });

        }
        if (dependentaddress.Country == "select") {

            message.Country = "Country is required"
            setmessage({ ...message });

        } else {
            message.Country = ""
            setmessage({ ...message });

        }
        if (dependentaddress.Pincode.trim() == "") {

            message.Pincode = "Pincode is required"
            setmessage({ ...message });

        } else {
            message.Pincode = ""
            setmessage({ ...message });
        }

        if (dependentData.IsInsured == 0) {
            dependentData.TypeOfInsurance = "select"
            dependentData.InsuredWith = ""
            setDependentData({ ...dependentData })
        }

        if (dependentData.IsEmployeed == 0) {
            dependentData.OrganizationName = "";
            dependentData.Designation = "";
            dependentData.Compensation = "";
            dependentData.WorkLocation = "";
            setDependentData({ ...dependentData })
        }
    }

    const cancelClick = () => {

        let valiclearoption = {
            id: "",
            Relationship: "select",
            Name: "",
            DOB: "",
            PlaceOfBirth: "",
            IsEmployeed: -1,
            OrganizationName: "",
            Designation: "",
            Compensation: "",
            WorkLocation: "",
            IsSmoker: -1,
            Nationality: "select",
            IsInsured: -1,
            TypeOfInsurance: "",
            InsuredWith: "",
            ContactNumber: "",
            AlternateNumber: "",
            DoTheyHavePassport: "",
            NameInPassport: "",
            PassportNumber: "",
            DateOfExpiry: "",
            DateOfIssue: "",
            PlaceOfIssue: "",
            ECNR: "",
        };
        setDependentData(valiclearoption);
        setShowPassportField(false);
        setShowEmploymentField(false);
        setInsuranceField(false);

        let clearvalue = {
            SameAsEmployeeAddress: "0",
            House_number: "",
            Street: "",
            Area: "",
            Town: "",
            State: "select",
            Country: "select",
            Pincode: ""
        }
        setDependentaddress(clearvalue);

        let validationFields = {
            Relationship: "",
            Name: "",
            DOB: "",
            PlaceOfBirth: "",
            IsEmployeed: "",
            OrganizationName: "",
            Designation: "",
            Compensation: "",
            WorkLocation: "",
            IsSmoker: "",
            Nationality: "",
            IsInsured: "",
            TypeOfInsurance: "",
            InsuredWith: "",
            ContactNumber: "",
            AlternateNumber: "",
            DoTheyHavePassport: "",
            NameInPassport: "",
            PassportNumber: "",
            DateOfExpiry: "",
            DateOfIssue: "",
            PlaceOfIssue: "",
            ECNR: "",
            SameAsEmployeeAddress: "",
            House_number: "",
            Street: "",
            Area: "",
            Town: "",
            State: "",
            Country: "",
            Pincode: ""

        }

        setmessage(validationFields);

        let rejexvalidation = {

            personalMailId: "",
            ContactNumber: "",
            AlternateNumber: ""

        }
        setRejexMessage(rejexvalidation);

        props.setIsDependentClicked(false);
        setHideForm(true);
        props.setHideDependentForm(true);

        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");
        $("body").removeClass("removeScroll");


    }



    const submitClick = async () => {

        try {  setDisableSubmitBtn(true);

            validation();

            let isEmployeedFieldsValid = true;
            let isInsuredFieldsValid = true;
            let isPassportFieldValid = true;
            let isRejexValid = true;

            if (contactNumber != "" || message.Name != "" || message.PlaceOfBirth != "" || message.Designation != "" || message.WorkLocation != "" ||
                message.InsuredWith != "" || message.NameInPassport != "" || message.PassportNumber != "" || message.House_number != "" || message.Street != "" ||
                message.Area != "" || message.Town) { isRejexValid = false }
            else { isRejexValid = true }

            if (dependentData.IsEmployeed == 1 && (dependentData.OrganizationName.trim() == "" || dependentData.Compensation.trim() == "" || dependentData.WorkLocation.trim() == "" || dependentData.Designation.trim() == "")) {

                isEmployeedFieldsValid = false;
            }

            if (dependentData.IsInsured == 1 && (dependentData.TypeOfInsurance == "select" || dependentData.InsuredWith.trim() == "")) {

                isInsuredFieldsValid = false;
            }

            if (dependentData.DoTheyHavePassport == 1 && (dependentData.NameInPassport.trim() == "" || dependentData.PassportNumber.trim() == "" || dependentData.DateOfIssue == "" ||
                dependentData.DateOfExpiry == "" || dependentData.PlaceOfIssue == "select" /*|| dependentData.ECNR == ""*/)) {
                isPassportFieldValid = false
            }

            if (pagemode == "false" && isRejexValid == true && isEmployeedFieldsValid == true && isInsuredFieldsValid == true && isPassportFieldValid == true) {
                if (
                    dependentData.Relationship != "select" &&
                    dependentData.Name.trim() != "" &&
                    dependentData.DOB != "" &&
                    dependentData.PlaceOfBirth.trim() != "" &&
                    dependentData.IsEmployeed != "-1" &&
                    dependentData.IsInsured != "-1" &&
                    dependentData.IsSmoker != "-1" &&
                    // dependentData.OrganizationName != "" &&
                    // dependentData.Designation != "" &&
                    // dependentData.Compensation != "" &&
                    // dependentData.WorkLocation != "" &&
                    dependentData.Nationality != "select" &&
                    // dependentData.TypeOfInsurance != "" &&
                    // dependentData.InsuredWith != "" &&
                    dependentData.ContactNumber.trim() != "" &&
                    //dependentData.AlternateNumber.trim() != "" &&
                    dependentaddress.House_number.trim() != "" &&
                    dependentaddress.Street.trim() != "" &&
                    dependentaddress.Area.trim() != "" &&
                    dependentaddress.Town.trim() != "" &&
                    dependentaddress.State != "select" &&
                    dependentaddress.Country != "select" &&
                    dependentaddress.Pincode.trim() != ""
                ) {
                    let insertdata = {
                        request_type: "Insert",
                        emp_id: EmpId,
                        login_emp_id: loginEmpId,
                        role: role,
                        relationship: dependentData.Relationship,
                        name: dependentData.Name,
                        dob: dependentData.DOB,
                        place_of_birth: dependentData.PlaceOfBirth,
                        is_employeed: dependentData.IsEmployeed,
                        organization_name: dependentData.OrganizationName,
                        designation: dependentData.Designation,
                        compensation: dependentData.Compensation,
                        work_location: dependentData.WorkLocation,
                        is_smoker: dependentData.IsSmoker,
                        nationality: dependentData.Nationality,
                        is_insured: dependentData.IsInsured,
                        type_of_insurance: dependentData.TypeOfInsurance,
                        insured_with: dependentData.InsuredWith,
                        contact_num: dependentData.ContactNumber,
                        alternate_num: dependentData.AlternateNumber,
                        same_emp_addr: dependentaddress.SameAsEmployeeAddress,
                        house_num: dependentaddress.House_number,
                        street: dependentaddress.Street,
                        area: dependentaddress.Area,
                        town: dependentaddress.Town,
                        state: dependentaddress.State,
                        country: dependentaddress.Country,
                        pincode: dependentaddress.Pincode,
                        do_they_have_passport: dependentData.DoTheyHavePassport ? 1 : 0,
                        name_in_pass: dependentData.NameInPassport,
                        pass_num: dependentData.PassportNumber,
                        date_of_issue: dependentData.DateOfIssue,
                        date_of_expiry: dependentData.DateOfExpiry,
                        Place_of_issue: dependentData.PlaceOfIssue,
                        ecnr: dependentData.ECNR
                    };



                    let responsedata = await postEmployeeDependentInfo(insertdata);
                    if (responsedata.data.status == 200) {
                        let valiclearoption = {
                            id: "",
                            Relationship: "select",
                            Name: "",
                            DOB: "",
                            PlaceOfBirth: "",
                            IsEmployeed: -1,
                            OrganizationName: "",
                            Designation: "",
                            Compensation: "",
                            WorkLocation: "",
                            IsSmoker: -1,
                            Nationality: "select",
                            IsInsured: -1,
                            TypeOfInsurance: "",
                            InsuredWith: "",
                            ContactNumber: "",
                            AlternateNumber: "",
                            SameAsEmployeeAddress: "0",
                            DoTheyHavePassport: "",
                            NameInPassport: "",
                            PassportNumber: "",
                            DateOfExpiry: "",
                            DateOfIssue: "",
                            PlaceOfIssue: "",
                            ECNR: "",
                        };
                        setDependentData(valiclearoption);

                        let clearvalue = {
                            SameAsEmployeeAddress: "0",
                            House_number: "",
                            Street: "",
                            Area: "",
                            Town: "",
                            State: "",
                            Country: "",
                            Pincode: ""
                        }
                        setDependentaddress(clearvalue);
                        cancelClick();

                        props.setHideToast('Submitted', 'Submitted Succesfully');
                        props.setIsDependentClicked(false);
                        props.getEmployeeDependent();
                    }

                }
            }
            else if (pagemode == "true") {

                if ((((role == "Hr Manager" || role == "Hr") && loginEmpId != EmpId) || (role == "Hr Manager" && loginEmpId == EmpId && reportstoId == loginEmpId)) && isRejexValid == true && isEmployeedFieldsValid == true && isInsuredFieldsValid == true && isPassportFieldValid == true) {
                    if (
                        dependentData.Relationship != "select" &&
                        dependentData.Name.trim() != "" &&
                        dependentData.DOB != "" &&
                        dependentData.PlaceOfBirth.trim() != "" &&
                        dependentData.IsEmployeed != "-1" &&
                        dependentData.IsInsured != "-1" &&
                        dependentData.IsSmoker != "-1" &&
                        // dependentData.OrganizationName != "" &&
                        // dependentData.Designation != "" &&
                        // dependentData.Compensation != "" &&
                        // dependentData.WorkLocation != "" &&
                        dependentData.Nationality != "select" &&
                        // dependentData.TypeOfInsurance != "" &&
                        // dependentData.InsuredWith != "" &&
                        dependentData.ContactNumber.trim() != "" &&
                        //dependentData.AlternateNumber.trim() != "" &&
                        dependentaddress.House_number.trim() != "" &&
                        dependentaddress.Street.trim() != "" &&
                        dependentaddress.Area.trim() != "" &&
                        dependentaddress.Town.trim() != "" &&
                        dependentaddress.State != "select" &&
                        dependentaddress.Country != "select" &&
                        dependentaddress.Pincode.trim() != ""
                    ) {
                        let updatedata = {
                            request_type: "Update",
                            emp_id: EmpId,
                            login_emp_id: loginEmpId,
                            role: role,
                            id: dependentData.id,
                            relationship: dependentData.Relationship,
                            name: dependentData.Name,
                            dob: dependentData.DOB,
                            place_of_birth: dependentData.PlaceOfBirth,
                            is_employeed: dependentData.IsEmployeed,
                            organization_name: dependentData.OrganizationName,
                            designation: dependentData.Designation,
                            compensation: dependentData.Compensation,
                            work_location: dependentData.WorkLocation,
                            is_smoker: dependentData.IsSmoker,
                            nationality: dependentData.Nationality,
                            is_insured: dependentData.IsInsured,
                            type_of_insurance: dependentData.TypeOfInsurance,
                            insured_with: dependentData.InsuredWith,
                            contact_num: dependentData.ContactNumber,
                            alternate_num: dependentData.AlternateNumber,
                            same_emp_addr: dependentaddress.SameAsEmployeeAddress,
                            house_num: dependentaddress.House_number,
                            street: dependentaddress.Street,
                            area: dependentaddress.Area,
                            town: dependentaddress.Town,
                            state: dependentaddress.State,
                            country: dependentaddress.Country,
                            pincode: dependentaddress.Pincode,
                            do_they_have_passport: dependentData.DoTheyHavePassport,
                            name_in_pass: dependentData.NameInPassport,
                            pass_num: dependentData.PassportNumber,
                            date_of_issue: dependentData.DateOfIssue,
                            date_of_expiry: dependentData.DateOfExpiry,
                            Place_of_issue: dependentData.PlaceOfIssue,
                            ecnr: dependentData.ECNR

                        };


                        let responsedata = await postEmployeeDependentInfo(updatedata);
                        if (responsedata.data.status == 200) {
                            let valiclearoption = {
                                id: "",
                                Relationship: "select",
                                Name: "",
                                DOB: "",
                                PlaceOfBirth: "",
                                IsEmployeed: -1,
                                OrganizationName: "",
                                Designation: "",
                                Compensation: "",
                                WorkLocation: "",
                                IsSmoker: -1,
                                Nationality: "select",
                                IsInsured: -1,
                                TypeOfInsurance: "",
                                InsuredWith: "",
                                ContactNumber: "",
                                AlternateNumber: "",
                                SameAsEmployeeAddress: "0",
                                DoTheyHavePassport: "",
                                NameInPassport: "",
                                PassportNumber: "",
                                DateOfExpiry: "",
                                DateOfIssue: "",
                                PlaceOfIssue: "",
                                ECNR: "",
                            };
                            setDependentData(valiclearoption);

                            let clearvalue = {
                                SameAsEmployeeAddress: "0",
                                House_number: "",
                                Street: "",
                                Area: "",
                                Town: "",
                                State: "",
                                Country: "",
                                Pincode: ""
                            }
                            setDependentaddress(clearvalue);
                            cancelClick();

                            props.setHideToast('Updated', 'Updated Succesfully');
                            props.setIsDependentClicked(false);
                            props.getEmployeeDependent();
                        }
                    } else {

                    }


                } else if ((role == "Team Member" || loginEmpId == EmpId) && isRejexValid == true && isEmployeedFieldsValid == true && isInsuredFieldsValid == true && isPassportFieldValid == true) {
                    if (
                        dependentData.Relationship != "select" &&
                        dependentData.Name.trim() != "" &&
                        dependentData.DOB != "" &&
                        dependentData.PlaceOfBirth.trim() != "" &&
                        dependentData.IsEmployeed != "-1" &&
                        dependentData.IsInsured != "-1" &&
                        dependentData.IsSmoker != "-1" &&
                        // dependentData.OrganizationName != "" &&
                        // dependentData.Designation != "" &&
                        // dependentData.Compensation != "" &&
                        // dependentData.WorkLocation != "" &&
                        dependentData.Nationality != "select" &&
                        // dependentData.TypeOfInsurance != "" &&
                        // dependentData.InsuredWith != "" &&
                        dependentData.ContactNumber.trim() != "" &&
                        //dependentData.AlternateNumber.trim() != "" &&
                        dependentaddress.House_number.trim() != "" &&
                        dependentaddress.Street.trim() != "" &&
                        dependentaddress.Area.trim() != "" &&
                        dependentaddress.Town.trim() != "" &&
                        dependentaddress.State != "select" &&
                        dependentaddress.Country != "select" &&
                        dependentaddress.Pincode.trim() != ""
                    ) {

                        let newvalue = {
                            relationship: dependentData.Relationship,
                            name: dependentData.Name,
                            dob: dependentData.DOB,
                            place_of_birth: dependentData.PlaceOfBirth,
                            is_employeed: dependentData.IsEmployeed,
                            organization_name: dependentData.OrganizationName,
                            designation: dependentData.Designation,
                            compensation: dependentData.Compensation,
                            work_location: dependentData.WorkLocation,
                            is_smoker: dependentData.IsSmoker,
                            nationality: dependentData.Nationality,
                            is_insured: dependentData.IsInsured,
                            type_of_insurance: dependentData.TypeOfInsurance == 'select' ? "" : dependentData.TypeOfInsurance,
                            insured_with: dependentData.InsuredWith,
                            contact_num: dependentData.ContactNumber,
                            alternate_num: dependentData.AlternateNumber,
                            same_emp_addr: dependentaddress.SameAsEmployeeAddress,
                            house_num: dependentaddress.House_number,
                            street: dependentaddress.Street,
                            area: dependentaddress.Area,
                            town: dependentaddress.Town,
                            state: dependentaddress.State,
                            country: dependentaddress.Country,
                            pincode: dependentaddress.Pincode,
                            do_they_have_passport: dependentData.DoTheyHavePassport,
                            name_in_pass: dependentData.NameInPassport,
                            pass_num: dependentData.PassportNumber,
                            date_of_issue: dependentData.DateOfIssue,
                            date_of_expiry: dependentData.DateOfExpiry,
                            Place_of_issue: dependentData.PlaceOfIssue,
                            ecnr: dependentData.ECNR
                        }

                        let oldvalue = {
                            relationship: Oldvalue.Relationship,
                            name: Oldvalue.Name,
                            dob: Oldvalue.DOB,
                            place_of_birth: Oldvalue.PlaceOfBirth,
                            is_employeed: Oldvalue.IsEmployeed,
                            organization_name: Oldvalue.OrganizationName,
                            designation: Oldvalue.Designation,
                            compensation: Oldvalue.Compensation,
                            work_location: Oldvalue.WorkLocation,
                            is_smoker: Oldvalue.IsSmoker,
                            nationality: Oldvalue.Nationality,
                            is_insured: Oldvalue.IsInsured,
                            type_of_insurance: Oldvalue.TypeOfInsurance == 'select' ? "" : Oldvalue.TypeOfInsurance,
                            insured_with: Oldvalue.InsuredWith,
                            contact_num: Oldvalue.ContactNumber,
                            alternate_num: Oldvalue.AlternateNumber,
                            same_emp_addr: Oldaddressvalue.SameAsEmployeeAddress,
                            house_num: Oldaddressvalue.House_number,
                            street: Oldaddressvalue.Street,
                            area: Oldaddressvalue.Area,
                            town: Oldaddressvalue.Town,
                            state: Oldaddressvalue.State,
                            country: Oldaddressvalue.Country,
                            pincode: Oldaddressvalue.Pincode,
                            do_they_have_passport: Oldvalue.DoTheyHavePassport,
                            name_in_pass: Oldvalue.NameInPassport,
                            pass_num: Oldvalue.PassportNumber,
                            date_of_issue: Oldvalue.DateOfIssue,
                            date_of_expiry: Oldvalue.DateOfExpiry,
                            Place_of_issue: Oldvalue.PlaceOfIssue,
                            ecnr: Oldvalue.ECNR
                        }

                        var NewValue = Object.keys(newvalue);
                        var OldValue = Object.keys(oldvalue);
                        var log_data = '{';
                        for (let i = 0; i <= NewValue.length; i++) {
                            if (newvalue[NewValue[i]] != oldvalue[OldValue[i]]) {

                                log_data += '"' + NewValue[i] + '"' + ':' + '"' + "'" + newvalue[NewValue[i]] + "'" + ',' + "'" + oldvalue[OldValue[i]] + "'" + '"' + ',';
                            }
                            if (i == NewValue.length) {

                                log_data = log_data.slice(0, -1);
                                log_data = log_data + "}";
                            }
                        }

                        if (log_data != '{' && log_data != '}') {
                            let logData = JSON.parse(log_data);

                            let updatedata = {
                                request_type: "Update",
                                emp_id: EmpId,
                                login_emp_id: loginEmpId,
                                category_id: dependentData.id,
                                category: "emp_dependent",
                                status: "Pending",
                                role: "Team Member",
                                log_data: logData

                            };

                            let emp = [];
                            notification.map((obj, index) => {

                                emp.push(obj.emp_id);
                            });

                            if (Object.keys(logData).length > 0) {

                                let responsedata = await postEmployeeDependentInfo(updatedata);
                                if (responsedata.data.status == 200) {

                                    let profileRequestId = responsedata.data.ResponseData[1];

                                    await NotificationTrigger({ title: "Profile Update", message: 'Profile Request', route: '/profileupdate', state: { state: { profileRequestId: profileRequestId } }, to_employee: emp, by: loginEmpId }, emp, props.websocket)

                                    let valiclearoption = {
                                        id: "",
                                        Relationship: "select",
                                        Name: "",
                                        DOB: "",
                                        PlaceOfBirth: "",
                                        IsEmployeed: -1,
                                        OrganizationName: "",
                                        Designation: "",
                                        Compensation: "",
                                        WorkLocation: "",
                                        IsSmoker: -1,
                                        Nationality: "select",
                                        IsInsured: -1,
                                        TypeOfInsurance: "",
                                        InsuredWith: "",
                                        ContactNumber: "",
                                        AlternateNumber: "",
                                        SameAsEmployeeAddress: "0",
                                        DoTheyHavePassport: "",
                                        NameInPassport: "",
                                        PassportNumber: "",
                                        DateOfExpiry: "",
                                        DateOfIssue: "",
                                        PlaceOfIssue: "",
                                        ECNR: "",
                                    };
                                    setDependentData(valiclearoption);

                                    let clearvalue = {
                                        SameAsEmployeeAddress: "0",
                                        House_number: "",
                                        Street: "",
                                        Area: "",
                                        Town: "",
                                        State: "",
                                        Country: "",
                                        Pincode: ""
                                    }
                                    setDependentaddress(clearvalue);
                                    cancelClick();
                                    props.setIsDependentClicked(false);
                                    props.setHideToast('Profile Request submitted', 'Changes will be reflected after the approval');
                                }
                            }
                        } else { cancelClick(); }
                        
                    }
                }
            }
             setDisableSubmitBtn(false);
        } catch (e) {
             setDisableSubmitBtn(false);

        }

    }



    const LoadDataEditView = async () => {

        let search = window.location.search;
        let params = new URLSearchParams(search);
        let Empid = params.get("EmpId");
        let Id = params.get("id");
        let Mode = params.get("pMode");

        setEmpId(Empid);

        let objedit = {
            emp_id: Empid,
            id: Id,
            reports_to: loginEmpId,
            role: role,
        };
        if (Mode == "Edit") {
            setpagemode("true");
            setSubmit("Update");
        }

    };

    const selecteditarray = async (objedit) => {

        
        try {
            setIsLoading(false);
            let responsedata = await getEmployeeDependentInfoForForm(objedit);

            if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {
                EditLoadstate(responsedata.data.ResponseData[0][0].country);

                let dataofbirth = moment(new Date(responsedata.data.ResponseData[0][0].dob));
                let Dateofbirth = dataofbirth.format("YYYY-MM-DD");

                let dateofexpiry = moment(new Date(responsedata.data.ResponseData[0][0].date_of_expiry));
                let DateOfExpiry = dateofexpiry.format("YYYY-MM-DD") == "Invalid date" ? "" : dateofexpiry.format("YYYY-MM-DD");

                let dateofissue = moment(new Date(responsedata.data.ResponseData[0][0].date_of_issue));
                let DateOfIssue = dateofissue.format("YYYY-MM-DD") == "Invalid date" ? "" : dateofissue.format("YYYY-MM-DD");


                responsedata.data.ResponseData[0][0].do_they_have_passport == 1 ? setShowPassportField(true) : setShowPassportField(false);
                responsedata.data.ResponseData[0][0].is_employeed == 1 ? setShowEmploymentField(true) : setShowEmploymentField(false);
                responsedata.data.ResponseData[0][0].is_insured == 1 ? setInsuranceField(true) : setInsuranceField(false);



                let oldvalueobj = {

                    id: responsedata.data.ResponseData[0][0].id,
                    Relationship: responsedata.data.ResponseData[0][0].relationship,
                    Name: responsedata.data.ResponseData[0][0].name,
                    DOB: Dateofbirth,
                    PlaceOfBirth: responsedata.data.ResponseData[0][0].place_of_birth,
                    IsEmployeed: responsedata.data.ResponseData[0][0].is_employeed,
                    OrganizationName: responsedata.data.ResponseData[0][0].organization_name,
                    Designation: responsedata.data.ResponseData[0][0].designation,
                    Compensation: responsedata.data.ResponseData[0][0].compensation,
                    WorkLocation: responsedata.data.ResponseData[0][0].work_location,
                    IsSmoker: responsedata.data.ResponseData[0][0].is_smoker,
                    Nationality: responsedata.data.ResponseData[0][0].nationality,
                    IsInsured: responsedata.data.ResponseData[0][0].is_insured,
                    TypeOfInsurance: responsedata.data.ResponseData[0][0].type_of_insurance,
                    InsuredWith: responsedata.data.ResponseData[0][0].insured_with,
                    ContactNumber: responsedata.data.ResponseData[0][0].contact_num,
                    AlternateNumber: responsedata.data.ResponseData[0][0].alternate_num,
                    DoTheyHavePassport: responsedata.data.ResponseData[0][0].do_they_have_passport,
                    NameInPassport: responsedata.data.ResponseData[0][0].name_in_pass,
                    PassportNumber: responsedata.data.ResponseData[0][0].pass_num,
                    DateOfExpiry: DateOfExpiry,
                    DateOfIssue: DateOfIssue,
                    PlaceOfIssue: responsedata.data.ResponseData[0][0].place_of_issue,
                    ECNR: responsedata.data.ResponseData[0][0].ecnr
                };
                setOldvalue(oldvalueobj);

                let oldAddress = {
                    SameAsEmployeeAddress: responsedata.data.ResponseData[0][0].same_emp_addr,
                    House_number: responsedata.data.ResponseData[0][0].house_num,
                    Street: responsedata.data.ResponseData[0][0].street,
                    Area: responsedata.data.ResponseData[0][0].area,
                    Town: responsedata.data.ResponseData[0][0].town,
                    State: responsedata.data.ResponseData[0][0].state,
                    Country: responsedata.data.ResponseData[0][0].country,
                    Pincode: responsedata.data.ResponseData[0][0].pincode,

                }
                setOldaddressvalue(oldAddress);

                let valiDateobj1 = {
                    id: responsedata.data.ResponseData[0][0].id,
                    Relationship: responsedata.data.ResponseData[0][0].relationship,
                    Name: responsedata.data.ResponseData[0][0].name,
                    DOB: Dateofbirth,
                    PlaceOfBirth: responsedata.data.ResponseData[0][0].place_of_birth,
                    IsEmployeed: responsedata.data.ResponseData[0][0].is_employeed,
                    OrganizationName: responsedata.data.ResponseData[0][0].organization_name,
                    Designation: responsedata.data.ResponseData[0][0].designation,
                    Compensation: responsedata.data.ResponseData[0][0].compensation,
                    WorkLocation: responsedata.data.ResponseData[0][0].work_location,
                    IsSmoker: responsedata.data.ResponseData[0][0].is_smoker,
                    Nationality: responsedata.data.ResponseData[0][0].nationality,
                    IsInsured: responsedata.data.ResponseData[0][0].is_insured,
                    TypeOfInsurance: responsedata.data.ResponseData[0][0].type_of_insurance,
                    InsuredWith: responsedata.data.ResponseData[0][0].insured_with,
                    ContactNumber: responsedata.data.ResponseData[0][0].contact_num,
                    AlternateNumber: responsedata.data.ResponseData[0][0].alternate_num,
                    DoTheyHavePassport: responsedata.data.ResponseData[0][0].do_they_have_passport,
                    NameInPassport: responsedata.data.ResponseData[0][0].name_in_pass,
                    PassportNumber: responsedata.data.ResponseData[0][0].pass_num,
                    DateOfExpiry: DateOfExpiry,
                    DateOfIssue: DateOfIssue,
                    PlaceOfIssue: responsedata.data.ResponseData[0][0].place_of_issue,
                    ECNR: responsedata.data.ResponseData[0][0].ecnr
                };

                setDependentData(valiDateobj1);


                let editAddress = {
                    SameAsEmployeeAddress: responsedata.data.ResponseData[0][0].same_emp_addr,
                    House_number: responsedata.data.ResponseData[0][0].house_num,
                    Street: responsedata.data.ResponseData[0][0].street,
                    Area: responsedata.data.ResponseData[0][0].area,
                    Town: responsedata.data.ResponseData[0][0].town,
                    State: responsedata.data.ResponseData[0][0].state,
                    Country: responsedata.data.ResponseData[0][0].country,
                    Pincode: responsedata.data.ResponseData[0][0].pincode,

                }

                setDependentaddress(editAddress)
                setIsLoading(true);
            }

            let NotaficationData = await getNotificationId(objedit);
            setNotification(NotaficationData.data.ResponseData[0]);
            setReportstoId(NotaficationData?.data?.ResponseData[0][0]?.emp_id);

        } catch (e) {

        }


    };

    return (
        <div className="modal fade show  longModal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }} hidden={hideForm}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <Loader isLoading={isLoading} />
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="DependantsLabel">
                            Dependents
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div className="employeeInfoScroll">
                        <div className="modal-body">
                            <div className="row mb-4">
                                <h1 className="profile-popup-subheader">Primary Info</h1>
                                <div className="col-md-6">
                                    <label htmlFor="dependant-relationship" className="form-label hive-form-label">
                                        Relationship<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <select
                                        className="form-select hive-form-select"
                                        aria-label="Default select example"
                                        id="dependant-relationship"
                                        name="Relationship"
                                        value={dependentData.Relationship}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    >
                                        <option selected>select</option>
                                        {buildRelationship()}
                                    </select>
                                    {message.Relationship ? <label className="hive-form-mandatory">{message.Relationship}</label> : null}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="dependant-name" className="form-label hive-form-label">
                                        Name<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="dependant-name"
                                        aria-describedby="Name"
                                        placeholder="Enter here"
                                        maxLength={225}
                                        name="Name"
                                        value={dependentData.Name}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.Name ? <label className="hive-form-mandatory">{message.Name}</label> : null}
                                </div>
                            </div>
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label htmlFor="dependant-date" className="form-label hive-form-label">
                                                Date of Birth<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control hive-form-control"
                                                id="dependant-date"
                                                aria-describedby="Date"
                                                name="DOB"
                                                value={dependentData.DOB}
                                                onChange={(e) => {
                                                    OnChangeName(e);
                                                }}
                                            />
                                            {message.DOB ? <label className="hive-form-mandatory">{message.DOB}</label> : null}
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="dependant-place" className="form-label hive-form-label">
                                                Place of Birth<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                id="dependant-place"
                                                aria-describedby="Place"
                                                placeholder="Enter here"
                                                maxLength={225}
                                                name="PlaceOfBirth"
                                                value={dependentData.PlaceOfBirth}
                                                onChange={(e) => {
                                                    OnChangeName(e);
                                                }}
                                            />
                                            {message.PlaceOfBirth ? (
                                                <label className="hive-form-mandatory">{message.PlaceOfBirth}</label>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="dependant-employed" className="form-label hive-form-label w-100">
                                        Is Employed?<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <div className="form-check form-check-inline mt-2">
                                        <input
                                            className="form-check-input hive-form-check-input"
                                            type="radio"
                                            id="Yes"
                                            name="IsEmployeed"
                                            checked={dependentData.IsEmployeed == 1 ? 1 : 0}
                                            value={dependentData.IsEmployeed}
                                            onClick={(e) => {
                                                OnRadioClick(e);
                                            }}
                                        />
                                        <label className="form-check-label hive-form-check-label" htmlFor="IsEmployedYes">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline mt-2">
                                        <input
                                            className="form-check-input hive-form-check-input"
                                            type="radio"
                                            id="No"
                                            name="IsEmployeed"
                                            checked={dependentData.IsEmployeed == 0 ? 1 : 0}
                                            value={dependentData.IsEmployeed}
                                            onClick={(e) => {
                                                OnRadioClick(e);
                                            }}
                                        />
                                        <label className="form-check-label hive-form-check-label" htmlFor="IsEmployedNo">
                                            No
                                        </label>
                                    </div>
                                    {message.IsEmployeed ? (
                                        <label className="hive-form-label w-100 hive-form-mandatory">{message.IsEmployeed}</label>
                                    ) : null}
                                </div>
                            </div>
                            {showEmploymentField ? (
                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <label
                                            htmlFor="dependant-organization"
                                            className="form-label hive-form-label"
                                            name="OrganizationName"
                                        >
                                            Organization Name<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="dependant-organization"
                                            aria-describedby="Organization"
                                            placeholder="Enter here"
                                            maxLength={255}
                                            name="OrganizationName"
                                            value={dependentData.OrganizationName}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.OrganizationName ? (
                                            <label className="hive-form-mandatory">{message.OrganizationName}</label>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="dependant-designation" className="form-label hive-form-label" name="Designation">
                                            Designation<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="dependant-designation"
                                            aria-describedby="Designation"
                                            placeholder="Enter here"
                                            maxLength={100}
                                            name="Designation"
                                            value={dependentData.Designation}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.Designation ? <label className="hive-form-mandatory">{message.Designation}</label> : null}
                                    </div>
                                </div>
                            ) : null}
                            {showEmploymentField ? (
                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <label
                                            htmlFor="dependant-compensation"
                                            className="form-label hive-form-label"
                                            name="Compensation"
                                            value={dependentData.Compensation}
                                        >
                                            Compensation<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="dependant-compensation"
                                            aria-describedby="Compensation"
                                            placeholder="Enter here"
                                            name="Compensation"
                                            value={dependentData.Compensation}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.Compensation ? (
                                            <label className="hive-form-mandatory">{message.Compensation}</label>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="dependant-location" className="form-label hive-form-label" name="WorkLocation">
                                            Work Location<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="dependant-location"
                                            aria-describedby="Location"
                                            placeholder="Enter here"
                                            maxLength={100}
                                            name="WorkLocation"
                                            value={dependentData.WorkLocation}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.WorkLocation ? (
                                            <label className="hive-form-mandatory">{message.WorkLocation}</label>
                                        ) : null}
                                    </div>
                                </div>
                            ) : null}
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <label htmlFor="dependant-smoker" className="form-label hive-form-label w-100">
                                        Smoker<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <div className="form-check form-check-inline mt-2">
                                        <input
                                            className="form-check-input hive-form-check-input"
                                            type="radio"
                                            id="Yes"
                                            name="IsSmoker"
                                            checked={dependentData.IsSmoker == 1 ? 1 : 0}
                                            value={dependentData.IsSmoker}
                                            onClick={(e) => {
                                                OnRadioClick(e);
                                            }}
                                        />
                                        <label className="form-check-label hive-form-check-label" htmlFor="IsSmokerYes">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline mt-2">
                                        <input
                                            className="form-check-input hive-form-check-input"
                                            type="radio"
                                            id="No"
                                            name="IsSmoker"
                                            checked={dependentData.IsSmoker == 0 ? 1 : 0}
                                            value={dependentData.IsSmoker}
                                            onClick={(e) => {
                                                OnRadioClick(e);
                                            }}
                                        />
                                        <label className="form-check-label hive-form-check-label" htmlFor="IsSmokerNo">
                                            No
                                        </label>
                                    </div>
                                    <div>{message.IsSmoker ? <label className="hive-form-mandatory">{message.IsSmoker}</label> : null}</div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label htmlFor="dependant-nationality" className="form-label hive-form-label">
                                                Nationality<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                className="form-select hive-form-select"
                                                aria-label="Default select example"
                                                id="dependant-nationality"
                                                name="Nationality"
                                                value={dependentData.Nationality}
                                                onChange={(e) => {
                                                    OnChangeName(e);
                                                }}
                                            >
                                                <option selected>select</option>
                                                {buildNationality()}
                                            </select>
                                            {message.Nationality ? (
                                                <label className="hive-form-mandatory">{message.Nationality}</label>
                                            ) : null}
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="dependant-insured" className="form-label hive-form-label w-100">
                                                Insured<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <div className="form-check form-check-inline mt-2">
                                                <input
                                                    className="form-check-input hive-form-check-input"
                                                    type="radio"
                                                    id="Yes"
                                                    name="IsInsured"
                                                    checked={dependentData.IsInsured == 1 ? 1 : 0}
                                                    value={dependentData.IsInsured}
                                                    onClick={(e) => {
                                                        OnRadioClick(e);
                                                    }}
                                                />
                                                <label className="form-check-label hive-form-check-label" htmlFor="IsInsuredYes">
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline mt-2">
                                                <input
                                                    className="form-check-input hive-form-check-input"
                                                    type="radio"
                                                    id="No"
                                                    name="IsInsured"
                                                    checked={dependentData.IsInsured == 0 ? 1 : 0}
                                                    value={dependentData.IsInsured}
                                                    onClick={(e) => {
                                                        OnRadioClick(e);
                                                    }}
                                                />
                                                <label className="form-check-label hive-form-check-label" htmlFor="IsInsuredNo">
                                                    No
                                                </label>
                                            </div>
                                            {message.IsInsured ? (
                                                <label className="hive-form-label w-100 hive-form-mandatory">{message.IsInsured}</label>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {showInsuranceField ? (
                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <label htmlFor="dependant-insurancetype" className="form-label hive-form-label">
                                            Type of Insurance<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <select
                                            className="form-select hive-form-select"
                                            aria-label="Default select example"
                                            id="dependant-insurancetype"
                                            name="TypeOfInsurance"
                                            value={dependentData.TypeOfInsurance}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        >
                                            <option value="select" selected>
                                                select
                                            </option>
                                            {buildInsuranceType()}
                                        </select>
                                        {message.TypeOfInsurance ? (
                                            <label className="hive-form-mandatory">{message.TypeOfInsurance}</label>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="dependant-insuredwith" className="form-label hive-form-label">
                                            Insured with<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="dependant-insuredwith"
                                            aria-describedby="Insured With"
                                            maxLength={100}
                                            placeholder="Enter here"
                                            name="InsuredWith"
                                            value={dependentData.InsuredWith}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.InsuredWith ? <label className="hive-form-mandatory">{message.InsuredWith}</label> : null}
                                    </div>
                                </div>
                            ) : null}
                            <div className="row mt-5">
                                <h1 className="profile-popup-subheader">Address Info</h1>
                                <div className="col-md-12 mb-3">
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input hive-form-check-input"
                                            type="checkbox"
                                            id="candidate-address"
                                            name="SameAsEmployeeAddress"
                                            checked={dependentaddress.SameAsEmployeeAddress == '0' ? false : true}
                                            onClick={(e) => {
                                                OnAddressChange(e);
                                            }}
                                        />
                                        <label className="form-check-label hive-form-check-label" htmlFor="candidate-address">
                                            Same as Candidate Address
                                        </label>
                                    </div>
                                </div>
                                {/* {showAddressField ? ( */}
                                <div className="row mt-5 ">
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="currentaddress-house" className="form-label hive-form-label">
                                            House / Building<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="currentaddress-house"
                                            aria-describedby="House / Building Name"
                                            name="House_number"
                                            placeholder="Enter here"
                                            value={dependentaddress.House_number}
                                            maxLength={225}
                                            onChange={(e) => {
                                                OnAddressChange(e);
                                            }}
                                        />
                                        {message.House_number ? (
                                            <label className="hive-form-mandatory">{message.House_number}</label>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="currentaddress-street" className="form-label hive-form-label">
                                            Road / Street / Lane
                                            <span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="currentaddress-street"
                                            aria-describedby="Road / Street / Lane"
                                            name="Street"
                                            placeholder="Enter here"
                                            value={dependentaddress.Street}
                                            maxLength={225}
                                            onChange={(e) => {
                                                OnAddressChange(e);
                                            }}
                                        />
                                        {message.Street ? <label className="hive-form-mandatory">{message.Street}</label> : null}
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="currentaddress-locality" className="form-label hive-form-label">
                                            Area / Locality / Sub Division
                                            <span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="currentaddress-locality"
                                            aria-describedby="Area / Locality / Sub Division"
                                            name="Area"
                                            placeholder="Enter here"
                                            value={dependentaddress.Area}
                                            maxLength={225}
                                            onChange={(e) => {
                                                OnAddressChange(e);
                                            }}
                                        />
                                        {message.Area ? <label className="hive-form-mandatory">{message.Area}</label> : null}
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="currentaddress-town" className="form-label hive-form-label">
                                            Town / City / District
                                            <span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="currentaddress-town"
                                            aria-describedby="Town / City / District"
                                            name="Town"
                                            placeholder="Enter here"
                                            value={dependentaddress.Town}
                                            maxLength={225}
                                            onChange={(e) => {
                                                OnAddressChange(e);
                                            }}
                                        />
                                        {message.Town ? <label className="hive-form-mandatory">{message.Town}</label> : null}
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="currentaddress-country" className="form-label hive-form-label">
                                            Country<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <select
                                            className="form-select hive-form-select"
                                            aria-label="Default select example"
                                            id="currentaddress-country"
                                            name="Country"
                                            value={dependentaddress.Country}
                                            onChange={(e) => {
                                                OnAddressChange(e);
                                                LoadDatacurrentstate(e);
                                            }}
                                        >
                                            <option selected="">select</option>
                                            {buildcurrentcountry()}
                                        </select>
                                        {message.Country ? <label className="hive-form-mandatory">{message.Country}</label> : null}
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="currentaddress-state" className="form-label hive-form-label">
                                            State<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <select
                                            className="form-select hive-form-select"
                                            aria-label="Default select example"
                                            id="currentaddress-state"
                                            name="State"
                                            value={dependentaddress.State}
                                            onChange={(e) => {
                                                OnAddressChange(e);
                                            }}
                                        >
                                            <option selected="">select</option>
                                            {buildcurrentstate()}
                                        </select>
                                        {message.State ? <label className="hive-form-mandatory">{message.State}</label> : null}
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="currentaddress-pincode" className="form-label hive-form-label">
                                            Pin Code<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="currentaddress-pincode"
                                            aria-describedby="Pin Code"
                                            name="Pincode"
                                            placeholder="Enter here"
                                            value={dependentaddress.Pincode}
                                            maxLength={6}
                                            onChange={(e) => {
                                                OnAddressChange(e);
                                            }}
                                        />
                                        {message.Pincode ? <label className="hive-form-mandatory">{message.Pincode}</label> : null}
                                    </div>
                                </div>
                                {/* ) : null} */}
                            </div>
                            <div className="row mb-5">
                                <h1 className="profile-popup-subheader">Contact Info</h1>
                                <div className="col-md-6 ">
                                    <label htmlFor="dependant-contact#" className="form-label hive-form-label">
                                        Contact No<span className="hive-form-mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control hive-form-control"
                                        id="dependant-contact#"
                                        aria-describedby="Contact #"
                                        placeholder="Enter here"
                                        maxLength={10}
                                        name="ContactNumber"
                                        value={dependentData.ContactNumber}
                                        onChange={(e) => {
                                            OnChangeName(e);
                                        }}
                                    />
                                    {message.ContactNumber ? <label className="hive-form-mandatory">{message.ContactNumber}</label> : null}
                                    {contactNumber ? <label className="hive-form-mandatory">{contactNumber}</label> : null}
                                </div>
                                {/* <div className="col-md-6 ">
                                <label htmlFor="dependant-alternate-contact#" className="form-label hive-form-label">Alternate Contact No<span className="hive-form-mandatory">*</span></label>
                                <input type="text" className="form-control hive-form-control" id="dependant-alternate-contact#" aria-describedby="Alternate Contact #"
                                    placeholder="Enter here" maxLength={10} name="AlternateNumber" value={dependentData.AlternateNumber} onChange={(e) => { OnChangeName(e) }} />
                                {message.AlternateNumber ? <label className="hive-form-mandatory">{message.AlternateNumber}</label> : null}
                                {AlternateNumber ? <label className="hive-form-mandatory">{AlternateNumber}</label> : null}
                            </div> */}
                            </div>
                            <div className="row mb-4">
                                <h1 className="profile-popup-subheader">Passport Info</h1>
                                <div className="col-md-12 mb-3">
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input hive-form-check-input"
                                            type="checkbox"
                                            id="candidate-passport"
                                            name="DoTheyHavePassport"
                                            checked={
                                                dependentData.DoTheyHavePassport == '0' || dependentData.DoTheyHavePassport == 0
                                                    ? false
                                                    : true
                                            }
                                            value={dependentData.DoTheyHavePassport}
                                            onClick={(e) => {
                                                handleChecked(e);
                                            }}
                                        />
                                        <label className="form-check-label hive-form-check-label" htmlFor="candidate-passport">
                                            Do they have passport?
                                        </label>
                                    </div>
                                </div>

                                {showPassportField ? (
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="dependant-passport-name" className="form-label hive-form-label">
                                            Name as in Passport<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="dependant-passport-name"
                                            aria-describedby="Passport Name"
                                            maxLength={225}
                                            placeholder="Enter here"
                                            name="NameInPassport"
                                            value={dependentData.NameInPassport}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.NameInPassport ? (
                                            <label className="hive-form-mandatory">{message.NameInPassport}</label>
                                        ) : null}
                                    </div>
                                ) : null}
                                {showPassportField ? (
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="dependant-passport#" className="form-label hive-form-label">
                                            Passport Number<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="dependant-passport#"
                                            aria-describedby="Passport #"
                                            placeholder="Enter here"
                                            maxLength={9}
                                            name="PassportNumber"
                                            value={dependentData.PassportNumber}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.PassportNumber ? (
                                            <label className="hive-form-mandatory">{message.PassportNumber}</label>
                                        ) : null}
                                    </div>
                                ) : null}

                                {showPassportField ? (
                                    <div className="row mb-4">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-6 mb-4">
                                                    <label htmlFor="dependant-date-issue" className="form-label hive-form-label">
                                                        Date of Issue<span className="hive-form-mandatory">*</span>
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control hive-form-control"
                                                        id="dependant-date-issue"
                                                        aria-describedby="Date Issued"
                                                        name="DateOfIssue"
                                                        value={dependentData.DateOfIssue}
                                                        onChange={(e) => {
                                                            OnChangeName(e);
                                                        }}
                                                    />
                                                    {message.DateOfIssue ? (
                                                        <label className="hive-form-mandatory">{message.DateOfIssue}</label>
                                                    ) : null}
                                                </div>
                                                <div className="col-md-6 mb-4">
                                                    <label htmlFor="dependant-expiry" className="form-label hive-form-label">
                                                        Date of Expiry<span className="hive-form-mandatory">*</span>
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control hive-form-control"
                                                        id="dependant-expiry"
                                                        aria-describedby="Expiry"
                                                        name="DateOfExpiry"
                                                        value={dependentData.DateOfExpiry}
                                                        onChange={(e) => {
                                                            OnChangeName(e);
                                                        }}
                                                    />
                                                    {message.DateOfExpiry ? (
                                                        <label className="hive-form-mandatory">{message.DateOfExpiry}</label>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-4">
                                            <label htmlFor="dependant-place-issue" className="form-label hive-form-label">
                                                Place of Issue<span className="hive-form-mandatory">*</span>
                                            </label>
                                            {/* <input type="text" className="form-control hive-form-control" id="dependant-place-issue" aria-describedby="Place Issued"
                                        name="PlaceOfIssue" value={dependentData.PlaceOfIssue} onChange={(e) => { OnChangeName(e); }} /> */}
                                            <select
                                                className="form-select hive-form-select"
                                                aria-label="Default select example"
                                                id="dependant-employment-type"
                                                maxLength={10}
                                                name="PlaceOfIssue"
                                                value={dependentData.PlaceOfIssue}
                                                onChange={(e) => {
                                                    OnChangeName(e);
                                                }}
                                            >
                                                <option selected>select</option>
                                                {buildPlaceOfIssue()}
                                            </select>
                                            {message.PlaceOfIssue ? (
                                                <label className="hive-form-mandatory">{message.PlaceOfIssue}</label>
                                            ) : null}
                                        </div>
                                    </div>
                                ) : null}
                                {showPassportField ? (
                                    <div className="row mb-4">
                                        <div className="col-md-6 mb-4">
                                            <label htmlFor="dependant-ECNR" className="form-label hive-form-label w-100">
                                                ECNR
                                            </label>
                                            <div className="form-check form-check-inline mt-2">
                                                <input
                                                    className="form-check-input hive-form-check-input"
                                                    type="radio"
                                                    id="Stamped"
                                                    name="ECNR"
                                                    checked={dependentData.ECNR == 'Stamped' ? 1 : 0}
                                                    value={dependentData.ECNR}
                                                    onClick={(e) => {
                                                        OnClickEcnr(e);
                                                    }}
                                                />
                                                <label className="form-check-label hive-form-check-label" htmlFor="Stamped">
                                                    Stamped
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline mt-2">
                                                <input
                                                    className="form-check-input hive-form-check-input"
                                                    type="radio"
                                                    id="yet to stamp"
                                                    name="ECNR"
                                                    checked={dependentData.ECNR == 'yet to stamp' ? 1 : 0}
                                                    value={dependentData.ECNR}
                                                    onClick={(e) => {
                                                        OnClickEcnr(e);
                                                    }}
                                                />
                                                <label className="form-check-label hive-form-check-label" htmlFor="yet to stamp">
                                                    Yet to Stamp
                                                </label>
                                            </div>
                                            <div>{message.ECNR ? <label className="hive-form-mandatory">{message.ECNR}</label> : null}</div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                            <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn hive-btn-primary"
                                onClick={() => {
                                    submitClick();
                                }}
                                disabled={DisableSubmitBtn}
                            >
                                {submit}
                            </button>
                        </div>
                </div>
            </div>
        </div>
    );
}


function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(DependentDetails)